import { advanceSearchConstants } from '../_constants/advance-search.constants';

export const updateAdvanceSearchQueries = (queries) => ({
	type: advanceSearchConstants.UPDATE_ADVANCE_SEARCH_QUERIES,
	payload: queries
});

export const updateDefaultQueriesAdvanceSearch = (queries) => ({
	type: advanceSearchConstants.UPDATE_DEFAULT_QUERIES_ADVANCE_SEARCH,
	payload: queries
});

export const resetQueriesAdvanceSearch = () => ({
	type: advanceSearchConstants.RESET_QUERIES_ADVANCE_SEARCH
});

export const fetchAdvanceSearchFiltersStart = () => ({
	type: advanceSearchConstants.FETCH_ADVANCE_SEARCH_FILTERS_START,
});

export const fetchAdvanceSearchFiltersSuccess = (data) => ({
	type: advanceSearchConstants.FETCH_ADVANCE_SEARCH_FILTERS_SUCCESS,
	payload: data
});

export const fetchAdvanceSearchFiltersFailure = (message) => ({
	type: advanceSearchConstants.FETCH_ADVANCE_SEARCH_FILTERS_FAILURE,
	payload: message
});

export const fetchAdvanceSearchStart = (data) => ({
	type: advanceSearchConstants.FETCH_ADVANCE_SEARCH_START,
	payload: data
});

export const fetchAdvanceSearchSuccess = (data) => ({
	type: advanceSearchConstants.FETCH_ADVANCE_SEARCH_SUCCESS,
	payload: data
});

export const fetchAdvanceSearchFailure = (message) => ({
	type: advanceSearchConstants.FETCH_ADVANCE_SEARCH_FAILURE,
	payload: message
});

export const updateNavDateChart = (dateType) => ({
	type: advanceSearchConstants.UPDATE_NAV_DATE_ADVANCE_SEARCH,
	payload: dateType
});

export const fetchNavAdvanceSearchStart = (data) => ({
	type: advanceSearchConstants.FETCH_NAV_ADVANCE_SEARCH_START,
	payload: data
});

export const fetchNavAdvanceSearchSuccess = (data) => ({
	type: advanceSearchConstants.FETCH_NAV_ADVANCE_SEARCH_SUCCESS,
	payload: data
});

export const fetchNavAdvanceSearchFailure = (message) => ({
	type: advanceSearchConstants.FETCH_NAV_ADVANCE_SEARCH_FAILURE,
	payload: message
});

export const updateCurrentPageSearch = (page) => ({
	type: advanceSearchConstants.UPDATE_CURRENT_PAGE_SEARCH,
	payload: page
});

export const updateTableColumn = (columnList) => ({
	type: advanceSearchConstants.UPDATE_TABLE_COLUMN,
	payload: columnList
});